"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function PlayCircleTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'play-circle',
    theme: 'twotone',
    nameWithTheme: 'play-circle-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1c-1.4 1-3 1.5-4.7 1.5-4.4 0-8-3.6-8-8V353c0-1.7.5-3.3 1.5-4.7 2.6-3.6 7.6-4.4 11.2-1.8l218.4 158.8c.7.5 1.3 1.1 1.8 1.8 2.6 3.5 1.8 8.5-1.8 11.1z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M676.1 505.3L457.7 346.5c-3.6-2.6-8.6-1.8-11.2 1.8-1 1.4-1.5 3-1.5 4.7v317.6c0 4.4 3.6 8 8 8 1.7 0 3.3-.5 4.7-1.5l218.4-158.9c3.6-2.6 4.4-7.6 1.8-11.1-.5-.7-1.1-1.3-1.8-1.8z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'play-circle-twotone';
var PlayCircleTwoTone = temp;
exports.default = PlayCircleTwoTone;